import axios from 'axios';

const api = axios.create({
  baseURL: process.env.REACT_APP_API_URL || 'http://localhost:3001/api',
  timeout: 10000,
});

// Request interceptor to add auth token
api.interceptors.request.use(
  (config) => {
    try {
      // Get token from localStorage directly (Supabase stores it there)
      const supabaseUrl = process.env.REACT_APP_SUPABASE_URL;
      if (supabaseUrl) {
        const projectRef = supabaseUrl.split('//')[1].split('.')[0];
        const authKey = `sb-${projectRef}-auth-token`;
        const authData = localStorage.getItem(authKey);
        
        if (authData) {
          const session = JSON.parse(authData);
          if (session?.access_token) {
            config.headers.Authorization = `Bearer ${session.access_token}`;
          }
        }
      }
    } catch (error) {
      console.log('Token retrieval failed:', error);
    }
    
    return config;
  },
  (error) => {
    return Promise.reject(error);
  }
);

// Response interceptor to handle errors
api.interceptors.response.use(
  (response) => response,
  (error) => {
    if (error.response?.status === 401) {
      // Handle unauthorized access - but don't redirect if already on auth pages
      const currentPath = window.location.pathname;
      const authPages = ['/login', '/signup', '/verify-phone', '/'];

      if (!authPages.some(page => currentPath.startsWith(page))) {
        console.log('Unauthorized access, redirecting to login...');
        localStorage.clear();
        window.location.href = '/login';
      }
    }

    return Promise.reject(error);
  }
);

export default api;